<template>
  <VueDatePicker
    v-model="date"
    ref="vueDatePicker"
    :name="name"
    :model-type="format"
    :format="formatProp"
    :min-date="minDate"
    :max-date="maxDate"
    :required="required"
    :disabled="disabled"
    :placeholder="placeholderProp"
    :input-class-name="inputClass"
    :state="invalidState ? false : null"
    :auto-apply="true"
    :enable-time-picker="withTime"
    :is-24="false"
    :time-picker-inline="true"
    :text-input="textInputOptions"
    :position="position"
    @closed="onClosed"
    autocomplete="off"
    teleport
  ></VueDatePicker>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  components: { VueDatePicker },

  emits: ['update:modelValue', 'closed'],

  props: {
    modelValue: {
      type: [Date, String, Number, Array],
      default: null
    },
    name: {
      type: String,
      default: null
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: ''
    },
    withTime: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    },
    invalidState: {
      type: Boolean,
      default: false
    },
    // Position: 'left' | 'center' | 'right'.
    position: {
      type: String,
      default: 'center'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  data: function () {
    return {
      date: this.modelValue,
    }
  },

  computed: {
    // This improves the parsing of the entered text.
    // For example, it allows "3/5/24" to be parsed as 03/05/2024.
    // It even allows to enter "3/5" and it is parsed as 03/05/[current year YYYY].
    textInputOptions() {
      return {
        format: (date) => {
          const parsed = moment(date, this.withTime ? 'MM/DD/YYYY hh:mm aa' : 'MM/DD/YYYY');
          if (!parsed.isValid()) return null;
          return parsed.toDate();
        },
      }
    },

    formatProp() {
      if (this.format !== '') return this.format;
      if (!this.withTime) return 'MM/dd/yyyy';
      return 'MM/dd/yyyy hh:mm aa';
    },

    placeholderProp() {
      if (this.placeholder !== '') return this.placeholder;
      if (!this.withTime) return 'MM/DD/YYYY';
      return 'MM/DD/YYYY HH:MM AM/PM';
    },

  },

  methods: {
    onClosed() {
      this.$nextTick(function () {
        this.$emit('closed');
      })
    },

    openMenu() {
      this.$refs.vueDatePicker.openMenu();
    }
  },

  watch: {
    modelValue: {
      handler(val) {
        this.date = val;
      },
      deep: true
    },

    date: {
      handler(val) {
        if (val instanceof Date) {
          val = moment(val).format(this.withTime ? 'MM/DD/YYYY hh:mm a' : 'MM/DD/YYYY');
        }
        this.$emit('update:modelValue', val);
      },
      deep: true
    },
  },

  mounted() {
    if (this.date instanceof Date) {
      this.date = moment(this.date).format(this.withTime ? 'MM/DD/YYYY hh:mm a' : 'MM/DD/YYYY');
    }
  }
}
</script>
